import React, { useState, useContext, useEffect, useCallback, useMemo } from "react";
import { SearchContext } from "./SearchContext/SearchProvider";
import { withRouter } from "react-router-dom";

export const HoveredFilterContext = React.createContext();

const HoveredFilterProvider = ({ children }) => {
  const context = useContext(SearchContext);
  const searchFilters = context.searchFilters;
  const [hoveredFilter, setHoveredFilter] = useState(null);

  useEffect(() => {
    setHoveredFilter(null);
  }, [searchFilters])

  /*
    name - handleHoveredRange
    return type - void
    description - if user hovers over a range filer on the track,
     this function deals with displaying a hovered filter on the header.

     params       type      description

    filter         {}         a filter object that contains filterName, filterType, filterValue
  */
  const handleHoveredRange = useCallback((name, type, value, min, max) => {
    const isInFilters = searchFilters.some(item => item.filterName === name);
    if (isInFilters) return;
    setHoveredFilter({
      min: min || value,
      max: max || value,
      filterType: type,
      filterName: name,
      filterValue: value
    });
  }, [searchFilters, setHoveredFilter]);

  /*
    name - handleHoveredSelectable
    return type - void
    description - if user hovers over a selectable filer on the track,
      this function deals with displaying a hovered filter on the header.

    params       type          description

    name           string         name of the selectable
    type           string         type  >> >>   >>

  */
  const handleHoveredSelectable = useCallback((name, type) => {
    const isInFilters = searchFilters.some(
      item => item.filterValue === name || item.filterName === name
    );
    if (isInFilters) return;
    setHoveredFilter({
      filterType: "selectable",
      filterName: type,
      filterValue: name
    });
  }, [searchFilters, setHoveredFilter]);

  const clearHoveredFilter = useCallback(() => {
    setHoveredFilter(undefined);
  }, [setHoveredFilter]);

  const value = useMemo(() => ({
    hoveredFilter,
    setHoveredFilter,
    handleHoveredRange,
    handleHoveredSelectable,
    clearHoveredFilter
  }),
    [
      hoveredFilter,
      setHoveredFilter,
      handleHoveredSelectable,
      handleHoveredRange,
      clearHoveredFilter
    ]
  );
  return (
    <HoveredFilterContext.Provider
      value={value}
    >
      {children}
    </HoveredFilterContext.Provider>
  );
};

export default withRouter(HoveredFilterProvider);
